<ling-input type="password" [formControl]="password"></ling-input>
<button
  mat-flat-button
  color="primary"
  (click)="onContinue()"
  style="margin: 0 auto"
>
  {{ "dialogs.enterPassword.continue" | translate }}
</button>
